// Animation duration constants for UI components
// These values must match corresponding CSS animation durations

/**
 * Duration for the day detail panel slide-in/slide-out animation
 * Must match the transition duration in DayDetailPanel.css
 */
export const PANEL_ANIMATION_DURATION_MS = 300
